/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const LoadActivityType = {
    Posted: 'POSTED',
    Booked: 'BOOKED',
    PickupGoodToGo: 'PICKUP_GOOD_TO_GO',
    DriverOnRoute: 'DRIVER_ON_ROUTE',
    DriverArrived: 'DRIVER_ARRIVED',
    DriverReadyToDepart: 'DRIVER_READY_TO_DEPART',
    StopVerified: 'STOP_VERIFIED',
    StopPassed: 'STOP_PASSED',
    Delivered: 'DELIVERED',
    Cancelled: 'CANCELLED',
    CancelledPermanently: 'CANCELLED_PERMANENTLY',
    CancelRequested: 'CANCEL_REQUESTED',
    CancelConfirmed: 'CANCEL_CONFIRMED'
} as const;
export type LoadActivityType = typeof LoadActivityType[keyof typeof LoadActivityType];

